/**
 * Palette unica dell'applicazione (identità DS Consulting: navy / oro / avorio).
 * Valori presi dal sito ufficiale DS Consulting (static/css/site-v3.css).
 * Importare COLORS da qui invece di ridefinire i colori nei singoli componenti.
 */
export const COLORS = {
  // Navy DS Consulting
  primary: '#0F1B2D',
  primaryHover: '#1A2B42',
  // Oro: '#84652B' è la variante leggibile su fondo chiaro, '#C9A961' quella su fondo navy
  accent: '#84652B',
  accentLight: '#C9A961',
  // Blu del marchio DS (logo)
  brandBlue: '#00679B',
  // Superfici
  bg: '#FAF9F6',
  surface: '#FFFFFF',
  text: '#0F1B2D',
  text2: '#5A6472',
  border: '#E4DFD2',
  softBlue: '#EEF3F5',
  softYellow: '#F1EDE4',
  ring: '#0F1B2D',
  // Stati
  success: '#2FBF71',
  error: '#DC2626',
};

export default COLORS;
